import { Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { ToastService } from "@app/services";
import { selectOperationsCanActivate } from "@app/state/selectors";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { filter, take, tap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class OperationGuard implements CanActivate {
  constructor(private store: Store, private toastService: ToastService) {}

  private waitForOperationsToLoad(): Observable<boolean> {
    return this.store.select(selectOperationsCanActivate).pipe(
      tap(
        (canActivate) =>
          !canActivate && this.toastService.show("Operations loading...")
      ),
      filter((canActivate) => canActivate),
      take(1)
    );
  }

  canActivate(): Observable<boolean> {
    return this.waitForOperationsToLoad();
  }
}
